/** "Contact us" (ux-bug-pass ticket 29) — not in API_SPEC.md; BACKEND_CONTRACT_GAPS.md gap 25. */
import { api } from './client';
import type { SupportMessageRequest, SupportMessageResponse } from './types';

export const supportApi = {
  send: (body: SupportMessageRequest) => api<SupportMessageResponse>('/v1/support/messages', { method: 'POST', body }),
};
